import {createContext} from 'react';
import {
    AuthUser,
    JWT
} from 'aws-amplify/auth';


type AuthContextType = {
    loading: boolean,
    user: AuthUser | undefined,
    idToken?: JWT | undefined,
    accessToken?: JWT | undefined,
    cognitoGroups?: string[] | undefined,
    role?: string | undefined,
    accountId?: string | undefined
}


export const AuthContext = createContext<AuthContextType>({
                                                              loading: true,
                                                              user: {} as AuthUser,
                                                              idToken: {} as JWT,
                                                              accessToken: {} as JWT,
                                                              cognitoGroups: [] as string[],
                                                              role: undefined,
                                                              accountId: undefined
                                                          });

